import { createFileRoute } from "@tanstack/react-router"
import { CompanyWorkspace } from "@/features/companies/company-workspace"
export const Route = createFileRoute("/_authenticated/companies/$companyId")({ component: CompanyWorkspace })
